import $ from 'jquery';

// Globals
var navExpanded = false;

//Functions

export function normalizeHeader() {
    navExpanded = false;
    $("header").css("--bg-color", "").css('background', '');
    $("nav").css("--normal-color", "").css("--hover-color", "");
    $("#menu-btn-svg").load('/assets/svg/menu.svg', () => $("#menu-btn span.md").text("Menü"));
    changeHeaderOnScroll();
}

export function controlNav(e) {
    const menuBtn = e.delegateTarget;
    const btnImg = $(menuBtn).children("#menu-btn-svg");
    const btnText = $(menuBtn).children("span.md");
    $("nav").slideToggle();
    navExpanded = !navExpanded;
    if (navExpanded) {
        $("header").css('background', '#fef5ef');
        $(btnImg).load('/assets/svg/cross.svg', () => $(btnText).text("Schließen"));
    } else {
        $("header").css('background', '');
        $(btnImg).load('/assets/svg/menu.svg', () => $(btnText).text("Menü"));
        if ($(".banner").length > 0)
            changeHeaderOnScroll();
    }
}
/**
* Method to change header colors when user scrolls the page. It calculates a value for transparency and two color variables.
* Transparency makes header white when user scrolls down, color changes nav links to dark color when user scrolls down, invcolor changes active nav link and hover colors to bright colors when user scrolls down
*/
export function changeHeaderOnScroll() {
    // skip if mobile nav not expanded, header is already intransparent when nav is expanded
    if (!navExpanded) {
        const ratio = window.scrollY / (window.outerHeight * 0.5); // check how far the user scrolled down
        // variables
        var bg_color = "#fef5ef"; // initial bg-color for the header (white)
        var transparency = 0; // integer holding the current value for the transparency of the header background
        var color; // string holding the font color for nav links, social links and menu button
        var invcolor; // string holding the inverted value of the color variable (for the active nav link and hover color for nav links)
        // conditional setting of color variables
        if (ratio < 0.125) {
            // if user scrolled less than 12.5% of window height
            transparency = 0; // full transparency
            color = ""; // white
            invcolor = ""; // black
        } else if (ratio > 0.9) {
            // if user scrolled more than 80% of window height
            transparency = 255; // no transparency
            color = "#1c0f13ff"; // black
            invcolor = "#fef5efff"; // white
        } else {
            // dynamic value while scrolling
            transparency = Math.round(ratio * 256); // value between 0 and 255 according to scroll ratio
            color = "#".concat((256 - transparency).toString(16).padStart(2, "0").repeat(3)); // the greater the transparency value, the darker the color
            invcolor = "#".concat(transparency.toString(16).padStart(2, "0").repeat(3)); // inverted color value
        }
        // append calculated transparency value to desired background color for the header
        $("header").css("--bg-color", bg_color.concat(transparency.toString(16).padStart(2, "0")));
        // set text color for all nav links (except the active one) and dropdowns
        $("nav").css("--normal-color", color);
        // set text color for active nav links and nav links on hover, the background color is inverted
        $("nav").css("--hover-color", invcolor);
        // set color for svgs for social links
        $(".social-link").each((index, element) => {
            $(element).css("color", color);
        })
    }
}